import { cn } from '@/lib/utils'
import { getSidebarIcon } from '@/components/sidebar/sidebar-icon-registry'
import type { SignupRoleConfig } from '@/constants/signup'

interface SignupRoleCardsProps {
  roles: SignupRoleConfig[]
  value: string | null
  onChange: (roleId: string) => void
  disabled?: boolean
  name?: string
}

export function SignupRoleCards({
  roles,
  value,
  onChange,
  disabled = false,
  name = 'signup-role',
}: SignupRoleCardsProps) {
  return (
    <div
      role="radiogroup"
      aria-label="Account type"
      className="grid grid-cols-1 gap-3 sm:grid-cols-2"
    >
      {roles.map((role) => {
        const selected = value === role.id
        const Icon = getSidebarIcon(role.icon ?? 'User')

        return (
          <label
            key={role.id}
            className={cn(
              'relative flex cursor-pointer flex-col overflow-hidden rounded-lg border bg-background transition-colors',
              'hover:border-primary/40',
              selected
                ? 'border-primary ring-1 ring-primary/30 bg-primary/5'
                : 'border-border/60',
              disabled && 'pointer-events-none opacity-50',
            )}
          >
            <input
              type="radio"
              name={name}
              value={role.id}
              checked={selected}
              onChange={() => onChange(role.id)}
              disabled={disabled}
              className="sr-only"
            />
            <div className="flex flex-col items-center gap-3 px-4 py-5 text-center lg:gap-2 lg:py-4">
              <Icon className="h-7 w-7 text-foreground" aria-hidden />
              <div className="space-y-1">
                <div className="text-sm font-semibold text-foreground">{role.label}</div>
                {role.description ? (
                  <p className="text-xs text-muted-foreground">{role.description}</p>
                ) : null}
              </div>
            </div>
          </label>
        )
      })}
    </div>
  )
}
